<template>
  <span
    class="icon"
    :class="getColor()"
    :title="scope.description"
    @click="(account.id != userId) ? $emit('toggle', { userId: userId, scopeId: scope.id }) : null">

    <i class="fas fa-check"></i>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'scope',
    'userId',
    'selected'
  ],
  computed: {
    ...mapGetters({
      account: 'account/account'
    })
  },
  methods: {
    getColor () {
      if (this.account.id === this.userId) {
        return (this.selected) ? 'has-text-grey-lighter' : 'has-text-white-ter'
      } else {
        return (this.selected) ? 'has-text-black' : 'has-text-grey-light'
      }
    }
  }
}
</script>
